export const GET_PIPE_RECEIVES = 'GET_PIPE_RECEIVES';
export const GET_PIPE_RECEIVES_PAGE = 'GET_PIPE_RECEIVES_PAGE';
export const PIPE_RECEIVE_REQUEST = 'PIPE_RECEIVE_REQUEST';
export const CREATE_PIPE_RECEIVE = 'CREATE_PIPE_RECEIVE';
export const UPDATE_PIPE_RECEIVE = 'UPDATE_PIPE_RECEIVE';
export const DELETE_PIPE_RECEIVE = 'DELETE_PIPE_RECEIVE';
export const PIPE_RECEIVE_REQUEST_FAILURE = 'PIPE_RECEIVE_REQUEST_FAILURE';
export const GET_PIPE_RECEIVES_WITH_DETAIL = 'GET_PIPE_RECEIVES_WITH_DETAIL';
export const PIPE_RECEIVE_REQUEST_SUCCESS  = 'PIPE_RECEIVE_REQUEST_SUCCESS';